export const DOUBLE_CROP_CHOICES = [
  { value: "primary-crop", display_name: "Primary Crop" },
  { value: "secondary-crop", display_name: "Secondary Crop" },
  { value: "cover-crop", display_name: "Cover Crop" },
  { value: "trial", display_name: "Trial" },
].sort(dropdownSort)

export const LEASE_TYPE_CHOICES = [
  { value: "non-lease", display_name: "Non-Lease" },
  { value: "per-acre-agreement", display_name: "Per Acre Agreement" },
  { value: "crop-share-payment", display_name: "Crop Share Payment" },
].sort(dropdownSort)

export const MONITOR_CHOICES = [
  { value: "gs2-2600", display_name: "GS2 2600" },
  { value: "gs3-2630", display_name: "GS3 2630" },
  { value: "ag-leader-integra", display_name: "Ag Leader Integra" },
  { value: "ag-leader-incommand", display_name: "Ag Leader Incommand" },
  { value: "trimble-fmx-1000", display_name: "Trimble FMX 1000" },
  { value: "trimble-fmx-2000", display_name: "Trimble FMX 2000" },
  { value: "claas-cebis", display_name: "Claas Cebis" },
  { value: "afs-pro-600", display_name: "AFS Pro 600" },
  { value: "afs-pro-700", display_name: "AFS Pro 700" },
  { value: "other", display_name: "Other" },
].sort(dropdownSort)

export const STARTER_FERTILIZER_CHOICES = [
  { value: "6-24-6", display_name: "6-24-6" },
  { value: "10-34-0", display_name: "10-34-0" },
  { value: "9-18-9", display_name: "9-18-9" },
  { value: "9-24-3", display_name: "9-24-3" },
  { value: "other", display_name: "Other" },
].sort(dropdownSort)

export const APPLICATION_METHOD_CHOICES = [
  { value: "dry", display_name: "Dry" },
  { value: "wet", display_name: "Wet" },
  { value: "manure", display_name: "Manure" },
].sort(dropdownSort)

export const WET_METHOD_TYPE_CHOICES = [
  { value: "injected", display_name: "Injected" },
  { value: "sprayed", display_name: "Sprayed" },
  { value: "other", display_name: "Other" },
  { value: "none", display_name: "None" },
].sort(dropdownSort)

export const DRY_METHOD_TYPE_CHOCIES = [
  { value: "broadcast", display_name: "Broadcast" },
  { value: "incorporated", display_name: "Incorporated" },
  { value: "strip till", display_name: "Strip Till" },
  { value: "banded", display_name: "Banded" },
  { value: "other", display_name: "Other" },
  { value: "none", display_name: "None" },
].sort(dropdownSort)

export const AAPFCO_TABLE = [
  {
    value: "nitrapyrin",
    display_name: "Nitrapyrin",
    mode: "Nitrification Inhibitor (slows ammonium to nitrate conversion below ground)",
    products: ["N-Serve®", "Instinct® NXTGEN"],
  },
  {
    value: "pronitridine",
    display_name: "Pronitridine",
    mode: "Nitrification Inhibitor (slows ammonium to nitrate conversion below ground)",
    products: ["Centuro®"],
  },
  {
    value: "dcd",
    display_name: "Dicyandiamide (DCD)",
    mode: "Nitrification Inhibitor (slows ammonium to nitrate conversion below ground)",
    products: ["Guardian®", "D-Crease™", "Generic/Private Label DCDs"],
  },
  {
    value: "nbpt",
    display_name: "NBPT (N-(n-butyl) thiophosphoric triamide)",
    mode: "Urease Inhibitor (prevents above-ground ammonia volatilization)",
    products: [
      "AGROTAIN® (Advanced, Ultra, Dri-Maxx)",
      "PinnitMax® TG",
      "N-Edge®",
      "NDURE® 2.0",
      "ContaiN®",
      "Nitrain®",
    ],
  },
  {
    value: "duromide_nbpt",
    display_name: "Duromide + NBPT",
    mode: "Advanced Urease Inhibitor (extended above-ground protection)",
    products: ["ANVOL®"],
  },
  {
    value: "nbpt_dcd",
    display_name: "NBPT + DCD (Combination)",
    mode: "Dual-Action Inhibitor (above and below-ground protection)",
    products: [
      "SuperU®",
      "NitroLock®",
      "NDURE TRIPLE DRY™",
      "Hi-Tec™",
      "ContaiN Duo™",
    ],
  },
].sort(dropdownSort)

export const DRY_FERT_PRODUCT_CHOICES = [
  {
    value: "tsp-0-46-0",
    display_name: "Triple Superphosphate (TSP 0-46-0)",
  },
  {
    value: "dap-18-46-0",
    display_name: "Diammonium phosphate (DAP 18-46-0)",
  },
  {
    value: "map-11-48-0",
    display_name: "Monoammonium phosphate (MAP 11-48-0)",
  },
  { value: "urea-46-0-0", display_name: "Urea (46-0-0)" },
  {
    value: "anhydrous-ammonia-82-0-0",
    display_name: "Anhydrous ammonia (82-0-0)",
  },
  {
    value: "ammonium-nitrate-34-0-0",
    display_name: "Ammonium nitrate (34-0-0)",
  },
  {
    value: "ammonium-sulfate-21-0-0-24",
    display_name: "Ammonium sulfate (21-0-0-24)",
  },
  {
    value: "ammonium-phosphate-dry-15-62-0",
    display_name: "Ammonium Phosphate dry (15-62-0)",
  },
  { value: "potash-0-0-60", display_name: "Potash (0-0-60)" },
  {
    value: "potassium-chloride-0-0-60",
    display_name: "Potassium chloride (0-0-60)",
  },
  {
    value: "potassium-magnesium-sulfate-0-0-22-22-11",
    display_name: "Potassium-magnesium sulfate (0-0-22-22-11(Mg))",
  },
  {
    value: "thiosulfate-0-0-25-17",
    display_name: "Potassium thiosulfate (0-0-25-17)",
  },
  {
    value: "potassium-nitrate-3-0-44",
    display_name: "Potassium nitrate (3-0-44)",
  },
  { value: "sulfate-0-0-50-18", display_name: "Sulfate (0-0-50-18)" },
  { value: "other", display_name: "Other" },
].sort(dropdownSort)

export const WET_FERT_PRODUCT_CHOICES = [
  { value: "uan32-32-0-0-0", display_name: "UAN32 (32-0-0-0)" },
  { value: "uan28-28-0-0-0", display_name: "UAN28 (28-0-0-0)" },
  {
    value: "ammonium-polyphosphate-liquid-10-34-0",
    display_name: "Ammonium polyphosphate liquid (10-34-0)",
  },
  { value: "28-0-0-5", display_name: "28-0-0-5" },
  { value: "32-0-0-5", display_name: "32-0-0-5" },
  { value: "aqua-ammonia-20-0-0", display_name: "Aqua ammonia (20-0-0)" },
  {
    value: "potassium-magnesium-sulfate-0-0-22-22-11",
    display_name: "Potassium magnesium sulfate (0-0-22-22-11Mg)",
  },
  {
    value: "potassium-nitrate-13-0-44",
    display_name: "Potassium nitrate (13-0-44)",
  },
  {
    value: "PGR",
    display_name: "Plant Growth Regulator (PGR)",
  },
  { value: "other", display_name: "Other" },
].sort(dropdownSort)

export const MANURE_PRODUCT_CHOICES = [
  { value: "cow-manure", display_name: "Manure - Liquid Cattle" },
  { value: "pig-manure", display_name: "Manure - Liquid Hog" },
  { value: "chicken_litter", display_name: "Manure - Chicken Litter" },
  { value: "turkey-manure", display_name: "Manure - Turkey" },
  {
    value: "pelletized_chicken_litter",
    display_name: "Pelletized Chicken Litter",
  },
  { value: "other", display_name: "Other" },
  { value: "none", display_name: "None" },
].sort(dropdownSort)

export const RATE_UNIT_CHOICES = [
  // { value: "lb", display_name: "lbs/acre" },
  // { value: "gal", display_name: "gal/acre" },
  { value: "lb/ac", display_name: "lb/ac" },
  { value: "gal/acre", display_name: "gal/acre" },
  { value: "none", display_name: "None" },
].sort(dropdownSort)

export const HEADER_WIDTH_CHOICES = [
  { value: "12", display_name: "12'" },
  { value: "24", display_name: "24'" },
  { value: "48", display_name: "48'" },
  { value: "64", display_name: "64'" },
  { value: "other", display_name: "Other" },
].sort(dropdownSort)

export const EQUIPMENT_CHOICES = [
  { value: "john-deere", display_name: "John Deere" },
  { value: "case", display_name: "Case" },
  { value: "new-holland", display_name: "New Holland" },
  { value: "kubota", display_name: "Kubota" },
  { value: "raven", display_name: "Raven" },
  { value: "other", display_name: "Other" },
].sort(dropdownSort)

export const LAB_CHOICES = [
  { value: "midwest", display_name: "Midwest" },
  { value: "waypoint", display_name: "Waypoint" },
  { value: "international-ag", display_name: "International Ag" },
  { value: "crop-services", display_name: "Crop Services" },
  {
    value: "university-of-arkansas",
    display_name: "University of Arkansas",
  },
  {
    value: "mississippi-state-university",
    display_name: "Mississippi State University",
  },
  { value: "a-and-l", display_name: "A & L" },
  { value: "brookside", display_name: "Brookside" },
  { value: "frontier", display_name: "Frontier" },
  { value: "waters", display_name: "Waters" },
  { value: "agvise", display_name: "AgVise" },
  { value: "other", display_name: "Other" },
].sort(dropdownSort)

export const SAMPLE_DENSITY_CHOICES = [
  { value: "none", display_name: "No Soil Samples" },
  { value: "<1", display_name: "< 1 Acre" },
  { value: "1-2", display_name: "1 to 2 Acres" },
  { value: "2-3", display_name: "2 to 3 Acres" },
  { value: "3-4", display_name: "3 to 4 Acres" },
  { value: "4-5", display_name: "4 to 5 Acres" },
  { value: "5-10", display_name: "5 to 10 Acres" },
  { value: ">10", display_name: "> 10 Acres" },
].sort(dropdownSort)

export const SAMPLE_NUTRIENT_CHOICES = [
  { value: "nitrate", display_name: "Nitrate" },
  { value: "phosphorus", display_name: "Phosphorus" },
  { value: "potassium", display_name: "Potassium" },
  { value: "chloride", display_name: "Chloride" },
  { value: "sulfur", display_name: "Sulfur" },
  { value: "boron", display_name: "Boron" },
  { value: "zinc", display_name: "Zinc" },
  { value: "iron", display_name: "Iron" },
].sort(dropdownSort)

export const SAMPLE_UNITS_CHOICES = [
  { value: "ppm", display_name: "ppm" },
  { value: "lb/ac", display_name: "lb/ac" },
].sort(dropdownSort)

export const SEEDING_RATE_UNIT_CHOICES = [
  { value: "seeds/ac", display_name: "seeds/ac" },
  { value: "lb/ac", display_name: "lb/ac" },
].sort(dropdownSort)

export const IRRIGATION_SOURCE_CHOICES = [
  { value: "surface", display_name: "Surface" },
  { value: "well", display_name: "Well" },
]

export const ALL_FERT_CHOICES = STARTER_FERTILIZER_CHOICES.concat(
  DRY_FERT_PRODUCT_CHOICES
)
  .concat(WET_FERT_PRODUCT_CHOICES)
  .concat(MANURE_PRODUCT_CHOICES)
  .sort(dropdownSort)
  .filter((v, i, a) => a.findIndex(t => t.value === v.value) === i)

export const CROP_PROTECTION_FUNGICIDE_CHOICES = [
  "Captan",
  "Chlorothalonil",
  "Mancozeb"
].sort((a, b) => a.localeCompare(b));

export const CROP_PROTECTION_INSECTICIDE_CHOICES = [
  "Imidacloprid",
  "Malathion",
  "Neonicotinoids"
].sort((a, b) => a.localeCompare(b));

export const CROP_PROTECTION_HERBICIDE_CHOICES = [
  "Glyphosate",
  "Atrazine",
  "2,4-D"
].sort((a, b) => a.localeCompare(b));

export const cropProtectionChoices = (method, type) => {
  if (type === "herbicide") {
    return CROP_PROTECTION_HERBICIDE_CHOICES;
  }
  if (type === "fungicide") {
    return CROP_PROTECTION_FUNGICIDE_CHOICES;
  }
  if (type === "insecticide") {
    return CROP_PROTECTION_INSECTICIDE_CHOICES;
  }

  return [];
}

export const SOIL_SAMPLE_TYPE_CHOICES = [
  { value: "composite", display_name: "Composite" },
  { value: "grid", display_name: "Grid" },
  { value: "zone", display_name: "Zone" },
]

function dropdownSort(a, b) {
  const exceptions = {
    None: -2,
    Other: -1,
  }
  if (exceptions[a.display_name] && exceptions[b.display_name]) {
    return exceptions[a.display_name] - exceptions[b.display_name]
  } else if (exceptions[a.display_name]) {
    return 1
  } else if (exceptions[b.display_name]) {
    return -1
  } else {
    return a.display_name.localeCompare(b.display_name)
  }
}

export const MAX_DEFAULT_FIELDS = 300

export const COLUMN_TOOLTIPS = {
  "irrigation": {
    "start_date": "Irrigation start date. Enter the date when irrigation season began for this field, regardless of frequency thereafter.",
    "end_date": "Irrigation end date. Enter the final irrigation date for the growing season on this field.",
    "source_of_water": "Water source for irrigation. Specify the origin of irrigation water.",
    "method": "Type of irrigation application method. Select the system used to apply water.",
    "method_type": "Details of the system used to apply water.",
    "amount": "Amount of water applied. Enter total seasonal irrigation water applied to this field. Include all applications throughout the growing season.",
    "unit": "Units of water amount.",
    "awd": "Primarily used in rice production. Select Yes if practicing controlled flooding cycles that allow fields to dry between irrigation events: this is the definition of the Alternate Wetting and Drying (AWD) method.",
    "awd_times": "Number of AWD cycles completed. Enter the total number of wet/dry cycles completed during the growing season if using AWD irrigation management.",
    "drainage": "Type of field drainage system. Select the drainage infrastructure on the field.",
    "wildlife_flood": "Field flooded for wildlife habitat. Select Yes if field was intentionally flooded during non-growing periods to provide waterfowl habitat or other wildlife benefits. This is a planned event that would be carried out intentionally.",
    "efficiency": "Irrigation efficiency percentage. Enter the estimated efficiency of the irrigation system."
  },
  "planting": {
    "date": "Date seed was put in the ground. Enter the actual planting date when seeds were placed in soil. This date is critical for carbon modeling and practice verification.",
    "rate": "Seeding rate quantity based on the units specified. Enter the actual rate used - may be seeds per acre, pounds per acre, or other units depending on crop type. This should match your planting equipment settings.",
    "unit": "Unit of measurement for planting rate. Select the appropriate unit that matches how you measured your seeding rate (seeds/acre, lbs/acre, etc.).",
    "manufacturer": "Manufacturer or brand name of the seed. Enter the company that produced the seed variety used (e.g., Pioneer, Dekalb, Channel).",
    "crop": "The specific crop type being planted. Select your primary crop from the dropdown. If your crop isn't listed, contact your support representative to request addition to the database.",
    "variety": "Specific crop variety information. Enter the exact variety name/number as labeled on the seed bag (e.g., P1197AM, DKC64-87RIB).",
    "seeds_per_bag": "Number of seeds contained in each bag. Enter the seed count per bag as specified on the seed packaging - used for calculating total seeds planted.",
    "cost_per_bag": "Cost per bag of seed. Optional field for economic tracking. Enter the price paid per bag of seed if you want to track input costs.",
    "biological": "Whether biological additives were used with seed. Enter the product name if seed was treated with biologicals, inoculants, or other additives beyond standard fungicides/insecticides. Contact CSM for guidance on qualifying products.",
    "monitor_type": "Type of yield monitor used during harvest. Select the brand/model of your combine's yield monitoring system. This helps validate reported yields and supports data quality.",
    "depth": "Seeding depth in inches. Enter the depth at which seed was placed in the soil. Use your planter's depth setting if uncertain.",
    "implement": "Implement used to plant the seed. Specify the exact equipment type (planter, drill, air seeder, etc.). This helps validate the seeding depth and rate reported."
  },
  "tillage": {
    "date": "Date when tillage was performed. Enter the specific date of the tillage operation. If multiple tillage passes occurred, create separate entries for each.",
    "depth": "Depth of tillage. Enter the actual working depth of the implement, not the total penetration depth. Use manufacturer specifications if uncertain.",
    "unit": "Unit of measurement for tillage depth. Select the appropriate unit that matches how you measured your tillage depth (inches or cm).",
    "method": "Type of tillage practice employed. Select the primary tillage method used. Contact support if your specific practice isn't listed in the dropdown options.",
    "implement": "Implement used for tillage operations. Specify the exact implement type (chisel plow, disk, strip-till, etc.). This helps validate the tillage classification selected."
  },
  "harvest": {
    "date": "Date the crop was harvested. Enter the actual harvest date when the crop was removed from the field. This date is critical for carbon modeling and practice verification.",
    "yield": "Total amount of crop harvested. Enter the actual yield achieved per acre. This should match your combine monitor readings or scale tickets from grain delivery.",
    "unit": "Unit of measurement for yield. Select the appropriate unit that matches how you measured your harvest (bu/ac, tons/ac, cwt/ac, etc.). Ensure consistency with your yield reporting.",
    "yield_moisture": "Moisture of the yield (expressed as a percentage range). Harvest Type is required for Corn to select a Yield Moisture.",
    "residue_removal": "Percentage of crop residue removed from field. Enter the estimated percentage of crop residue that was removed through baling, chopping, or other collection methods. Leaving residue helps soil health and carbon sequestration.",
    "residue_burned": "Whether crop residue was burned. Select Yes if any crop residue was intentionally burned after harvest. Burning releases carbon and reduces soil organic matter benefits.",
    "harvest_type": "Method used for harvesting the crop. Select the harvesting approach used - this affects residue management and carbon calculations."
  },
  "liming": {
    "date": "Date of lime/amendment application. Enter the actual application date for liming materials or soil amendments.",
    "type": "Type of lime/amendment applied. Select the specific type used: Agricultural lime, Dolomitic lime, Pelletized lime, Gypsum, or Other amendments.",
    "amount": "Amount applied per acre. Enter the application rate per acre or hectare, NOT total field tonnage. Example: 1.5 tons/acre, not 150 tons total for a 100-acre field.",
    "unit": "Unit of measurement for liming amount. 'tn/ac' indicates short tons (2000lb) per acre.",
  },
  "cover_crop": {
    "plant_date": "Cover crop planting date. Enter the date when cover crop seeds were planted or established on this field.",
    "family": "Cover crop family classification. Select the primary family: Legume (nitrogen-fixing), Grass (carbon accumulation), Brassica (soil health), or Mixed species combination.",
    "type": "Type of cover crop planted. Specify the exact species or mix planted: Crimson clover, Winter rye, Radishes, Multi-species mix, etc.",
    "interseeded": "Interseeded cover crop. Select Yes if cover crop was planted into standing cash crop before harvest (e.g., aerial seeding into soybeans).",
    "termination_date": "Cover crop termination date. Enter the date if cover crop was killed, mowed, or otherwise terminated before cash crop planting.",
    "depth": "Cover crop seeding depth in inches. Enter the depth at which cover crop seed was placed. Enter 0 for broadcast or aerial seeding left on the surface.",
    "implement": "Implement used to seed the cover crop. Specify the exact equipment type (drill, broadcast spreader, aerial, interseeder, etc.)."
  },
  "soil_sampling": {
    "type": "Type of soil sampling method. Select the sampling approach: Grid sampling (GPS-based), Zone sampling (management zones), Composite sampling (field average), or Random sampling methods.",
    "date": "Date of soil sampling collection"
  },
  "grazing": {
    "start_date": "Grazing start date. Enter the date when livestock were first allowed on this field for the grazing period being reported.",
    "end_date": "Grazing end date. Enter the date when livestock were removed from this field or grazing concluded for this period.",
    "animal_type": "Type of grazing animals. Select the specific animal type: Cattle (cow-calf pairs), Cattle (steers/heifers), Sheep, Goats, or other livestock species.",
    "stocking_rate": "Average stocking rate. Enter the average number of animal units (by type) grazing per acre during the grazing period. Calculate per animal type - if multiple species grazed, create separate entries. For cow-calf pairs: count each pair as 1 animal unit, not 2 animals. Example: 30 cow-calf pairs on 20 acres = 1.5 pairs per acre. Always normalize by acreage, never enter total headcount.",
    "stocking_rate_units": "Unit of measurement for stocking rate.",
    "rest_period": "Rest period between grazing cycles. Enter days between grazing periods if using rotational/intensive grazing management. Leave blank for continuous grazing systems.",
    "utilization": "Percent of total biomass consumed. Enter estimated percentage of all available plant material consumed by livestock, including crop residue, cover crops, and natural vegetation."
  },
  "conservation_programs": {
    "rcpp": "Regional Conservation Partnership Program (RCPP) participation. Select Yes if enrolled in RCPP funding for conservation practices implementation with local partners.",
    "cscg": "Climate Smart Commodities Grant (CSCG) participation. Select Yes if enrolled in CSCG program receiving payments for climate smart practices.",
    "eqip": "Environmental Quality Incentives Program (EQIP) participation. Select Yes if receiving EQIP cost-share assistance for implementing conservation practices.",
    "csp": "Conservation Stewardship Program (CSP) participation. Select Yes if enrolled in NRCS CSP program receiving payments for maintaining and improving conservation activities.",
    "non_deforestation": "Non-deforestation commitment compliance. Select Yes if operating under supply chain commitments that prohibit conversion of forest or native land to agricultural production.",
    "pay_for_practice": "Pay-for-practices program participation. Select Yes if receiving payments from private companies, NGOs, or other entities for implementing specific conservation practices.",
    "carbon_offset": "Carbon offset program participation. Select Yes if enrolled in carbon credit programs or carbon sequestration payment schemes beyond this platform.",
    "other_scope_3": "Other Scope 3 program participation. Select Yes if enrolled in other carbon intensity, carbon inset, or emissions reduction payment schemes beyond this platform."
  },
  "fsa": {
    "fsa_producer_name": "FSA producer name for identification. Enter the producer name exactly as registered with Farm Service Agency for compliance and verification purposes.",
    "fsa_farm_name": "FSA farm name for identification. Enter the farm name exactly as registered with FSA for official record matching and program eligibility.",
    "fsa_farm_id": "FSA farm identification number. Enter the official FSA farm number assigned to this operation for government program participation and tracking.",
    "fsa_tract_id": "FSA tract identification number. Enter the FSA tract number that contains this field for official boundary and acreage verification.",
    "fsa_field_id": "FSA field identification number. Enter the specific FSA field number that corresponds to this field for precise identification and compliance reporting."
  },
  "fertilizer": {
    "date": "Date of fertilizer application. Enter the actual application date. Create separate entries for each application event, even if using the same product.",
    "category": "Select organic if manure or compost was applied, select synthetic for a chemical mix application.",
    "method": "Application method for fertilizer. IMPORTANT: Select method FIRST, then select product. \n\nDefinitions: \n\nBanded: Applied in narrow strips, typically near crop rows.\n\nBroadcast: Uniformly applied across the entire field surface.\n\nCompost: Organic fertilizer type, not an application method.\n\nFertigation: Applied by dissolving fertilizer in irrigation water.\n\nFoliar: Sprayed directly onto plant leaves.\n\nIn Furrow: Applied directly into the seed furrow during planting.\n\nIncorporated: Applied to surface, then mixed into soil by tillage.\n\nInjected: Applied below the soil surface using specialized equipment.\n\nManure: Organic fertilizer type, not an application method.\n\nNone: No fertilizer application occurred.\n\nSprayed: Applied as a liquid spray (can be broadcast or foliar).",
    "product": "Type of fertilizer product applied. Start typing to search our database of thousands of products. If not found, select \"Other\" to create custom NPKS values. To add commonly used fertlizers to the list, request via support chat.",
    "organic_storage": "For organic fertilizer, this indcates how it is collected and stored before application. This value is not used for synthetic fertilizer.",
    "rate": "Application rate for fertilizer. Enter the rate per acre as applied. Must match the units selected and the method chosen above.",
    "unit": "Units for fertilizer measurement. Units auto-populate based on application method selected. Liquids default to gal/acre, solids to lb/acre or ton/acre.",
    "cost": "Cost of fertilizer product per ton. Optional economic tracking field. Enter the price paid per unit of fertilizer if cost tracking is desired.",
    "n": "Pounds of Nitrogen (N) applied per acre. This is calculated from the total product applied and its analysis. In the Management Practices Worksheet view, you can overwrite the calculated value. ",
    "p": "Pounds of Phosphorus (P2O5) applied per acre. This is calculated from the total product applied and its analysis. In the Management Practices Worksheet view, you can overwrite the calculated value. ",
    "k": "Pounds of Potassium (K2O) applied per acre. This is calculated from the total product applied and its analysis. In the Management Practices Worksheet view, you can overwrite the calculated value. ",
    "s": "Pounds of Sulfur applied per acre. Enter sulfur percentage if present in the fertilizer analysis. Leave blank if sulfur is not included in the product.",
    "slow_release": "Slow-release fertilizers are designed to gradually release nutrients over an extended period, providing a continuous supply to plants and minimizing nutrient loss. Examples include polymer-coated urea (PCU), sulfur-coated urea (SCU), urea-formaldehyde (UF), and isobutylidenediurea (IBDU).",
    "inhibitor": "Using nitrification inhibitor with fertilizer. Select Yes if nitrogen inhibitor technology was used (e.g., N-Serve, Instinct). Must be verified as modeled product with CSM.",
    "inhibitor_type": "Select the AAPFCO-recognized active ingredient used. Required for 45Z compliance documentation.",
    "vrt": "Using Variable Rate Technology for application. Select Yes if fertilizer rates were varied across the field using GPS/prescription maps rather than uniform application.",
    "management_plan": "Using a fertilizer management plan. Select Yes if you follow: • A formal plan developed by certified agronomist • Pre-season fertility planning documents • 4R-based nutrient management strategy • Written fertilizer recommendations based on soil tests.",
    "four_r": "Following 4R nutrient stewardship principles. Select Yes if fertilizer practices follow the 4Rs framework: Right Source (appropriate fertilizer type), Right Rate (soil test-based rates), Right Time (application timing for crop uptake), Right Place (proper placement for root access). ",
    "depth": "Application depth in inches. Enter the depth at which fertilizer was placed below the soil surface. Enter 0 for broadcast or surface-applied fertilizer that was not incorporated."
  },
  "crop_protection": {
    "date": "Date of crop protection application. Enter the actual application date. Create separate entries for tank mixes or multiple application timings.",
    "method": "Application method for crop protection. Select how the product was applied: Ground spray, Aerial application, In-furrow, Seed treatment, or other delivery method.",
    "type": "Type of crop protection product. Specify the category: Herbicide, Insecticide, Fungicide, Growth regulator, or combination products.",
    "product": "Product name or active ingredient. Select or enter the commercial product name or active ingredient. Be specific to help identify the exact formulation used.",
    "unit": "Units for crop protection product application rate. Select the unit that matches your application rate (fl oz/acre, lbs/acre, etc.). Must align with rate entry.",
    "rate": "Application rate for crop protection. Enter the rate per acre as specified on the label and actually applied to the field.",
    "ipm": "Integrated Pest Management (IPM) practices used. Select Yes if you employed IPM strategies: Economic thresholds (treating only when pest levels justify cost), Beneficial insects (encouraging natural predators), Crop rotation for pest break cycles, Resistant varieties, Cultural controls (tillage timing, planting dates), Precision application (spot treatments), or Scout-based decisions rather than calendar spraying.",
    "iwm": "Integrated Weed Management (IWM): A holistic approach to weed control that combines various strategies to manage weed populations and minimize their impact. It emphasizes prevention, cultural practices (e.g., crop rotation, cover cropping), mechanical methods (e.g., tillage, hand-weeding), biological control (e.g., natural enemies), and responsible chemical use (e.g., herbicide resistance management) to achieve long-term, sustainable weed suppression.",
    "idm": "Integrated Disease Management (IDM) practices used: Select Yes if you employed IDM strategies: Economic thresholds (treating only when disease levels justify cost), Beneficial microorganisms (encouraging biological control agents, natural antagonists), Crop rotation for disease break cycles, Resistant varieties, Cultural controls (spacing, timing, planting dates), Precision application (targeted treatments), or Scout-based decisions rather than calendar spraying."
  },
};
